webpackJsonp([84779536864874],{

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _Section = __webpack_require__(34);
	
	var _Headers = __webpack_require__(24);
	
	var _CodeBlock = __webpack_require__(38);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = function () {
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(
	      _Headers.PageHeader,
	      null,
	      'Getting Started'
	    ),
	    React.createElement(
	      _Section.Section,
	      { title: 'Installation' },
	      React.createElement(
	        'ol',
	        null,
	        React.createElement(
	          'li',
	          null,
	          React.createElement(
	            'p',
	            null,
	            'First, make sure you have the bright-js-framework cli installed globally.'
	          ),
	          React.createElement(
	            _CodeBlock.CodeBlock,
	            { language: 'bash' },
	            'npm install -g @brightinteractive/bright-js-framework'
	          )
	        ),
	        React.createElement(
	          'li',
	          null,
	          React.createElement(
	            'p',
	            null,
	            'Create a new directory for your project and initialize it.'
	          ),
	          React.createElement(
	            _CodeBlock.CodeBlock,
	            { language: 'bash' },
	            'mkdir my-project',
	            '\n',
	            'cd my-project',
	            '\n',
	            'bright-js-framework init'
	          )
	        ),
	        React.createElement(
	          'li',
	          null,
	          React.createElement(
	            'p',
	            null,
	            'bright-js-framework includes a cli tool for starting development & production servers, building production asset bundles, etc.'
	          ),
	          React.createElement(
	            'p',
	            null,
	            'Start up a new development server:'
	          ),
	          React.createElement(
	            _CodeBlock.CodeBlock,
	            { language: 'bash' },
	            'bright-js-framework run'
	          )
	        ),
	        React.createElement(
	          'li',
	          null,
	          React.createElement(
	            'p',
	            null,
	            'Pages are picked up from all files under the ',
	            React.createElement(
	              'code',
	              null,
	              'src/pages'
	            ),
	            ' directory.'
	          ),
	          React.createElement(
	            'p',
	            null,
	            'You\'ll see that the skeleton project contains a couple of placeholder pages.'
	          ),
	          React.createElement(
	            _CodeBlock.CodeFile,
	            { path: 'src/pages/IndexPage.tsx' },
	            __webpack_require__(662)
	          )
	        ),
	        React.createElement(
	          'li',
	          null,
	          React.createElement(
	            'p',
	            null,
	            'Visit ',
	            React.createElement(
	              'a',
	              { href: 'http://localhost:8000' },
	              'http://localhost:8000'
	            ),
	            ' and verify that you can see \u201CHello, world!\u201D on the page.'
	          )
	        )
	      )
	    ),
	    React.createElement(
	      _Section.Section,
	      { title: 'Routing' },
	      React.createElement(
	        'p',
	        null,
	        'As we saw in the previous section, pages are picked up from your app\'s ',
	        React.createElement(
	          'code',
	          null,
	          'src/pages'
	        ),
	        ' directory. bright-js-framework provides a ',
	        React.createElement(
	          'code',
	          null,
	          '@route'
	        ),
	        ' decorator, which is used to declare that a component should be used as the top-level component for a page route.'
	      ),
	      React.createElement(
	        'p',
	        null,
	        'Route components can be fully or partially dynamic and extract path params from sections. They also receive a special set of props from the page, providing the location, path params and query params:'
	      ),
	      React.createElement(
	        _CodeBlock.CodeFile,
	        { path: 'src/pages/UserPage.tsx' },
	        __webpack_require__(664)
	      ),
	      React.createElement(
	        'p',
	        null,
	        React.createElement(
	          'code',
	          null,
	          '*'
	        ),
	        ' can be used as a wildcard component (eg. ',
	        React.createElement(
	          'code',
	          null,
	          '/onboarding/*'
	        ),
	        '). It can also be used to produce a 404 page. The skeleton project includes an example of using this.'
	      ),
	      React.createElement(
	        _CodeBlock.CodeFile,
	        { path: 'src/pages/404.tsx' },
	        __webpack_require__(661)
	      )
	    ),
	    React.createElement(
	      _Section.Section,
	      { title: 'Navigating to other pages' },
	      React.createElement(
	        'p',
	        null,
	        'It is important not to use the HTML ',
	        React.createElement(
	          'code',
	          null,
	          '<a />'
	        ),
	        ' element to navigate to other pages on the site. Using this element will perform a full page load, which will be slow, won\u2019t use any animations that you have designed, and will loose any client-side state.'
	      ),
	      React.createElement(
	        'p',
	        null,
	        'Instead, use Bright-js-framework\u2019s ',
	        React.createElement(
	          'code',
	          null,
	          '<Link />'
	        ),
	        ' element, which is a drop-in replacement for ',
	        '<a />',
	        ' that functions correctly.'
	      ),
	      React.createElement(
	        _CodeBlock.CodeFile,
	        { path: 'src/pages/LinksPage.tsx' },
	        __webpack_require__(663)
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

	module.exports = "import * as React from 'react'\nimport { route, RouteProps } from '@brightinteractive/bright-js-framework'\n\n@route('*')\nexport class NotFoundPage extends React.PureComponent<RouteProps> {\n  render() {\n    return <h1>404 Not Found</h1>\n  }\n}\n"

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

	module.exports = "import * as React from 'react'\nimport { RouteProps, route } from '@brightinteractive/bright-js-framework'\n\n@route('/')\nexport class IndexPage extends React.PureComponent<RouteProps> {\n  render() {\n    return <div>Hello, world!</div>\n  }\n}\n"

/***/ }),

/***/ 663:
/***/ (function(module, exports) {

	module.exports = "import * as React from 'react'\nimport { RouteProps, Link, route } from '@brightinteractive/bright-js-framework'\n\n@route('/link')\nexport class LinksPage extends React.PureComponent<RouteProps> {\n  render() {\n    return <Link href=\"/\">Home</Link>\n  }\n}\n"

/***/ }),

/***/ 664:
/***/ (function(module, exports) {

	module.exports = "import * as React from 'react'\nimport { route, RouteProps } from '@brightinteractive/bright-js-framework'\n\nexport type UserPageParams = 'name'\n\n@route('/users/:name')\nexport class UserPage extends React.PureComponent<RouteProps<UserPageParams>> {\n  render() {\n    return <div>Hello, {this.props.pathParams.name}!</div>\n  }\n}\n"

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-docs-getting-started-js-6cca21ff36500882dcfd.js